// ABOUTME: Renders the replaceable NovaName Play identity from one asset boundary.
// ABOUTME: The clipped nameplate and lowercase n work in normal and inverse contexts.
import type { CSSProperties } from "react";

export function BrandMark({
  className = "",
  style,
}: {
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <svg
      className={`brand-mark ${className}`}
      style={style}
      viewBox="0 0 68 50"
      aria-hidden="true"
    >
      <path
        className="brand-mark-plate"
        d="M4 0h46.4q.6 0 1 .4l16.2 16.2q.4.4.4 1V46a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4Z"
      />
      <path
        className="brand-mark-letter"
        d="M17.8 41.6q-1.2 0-1.2-1.2V16q0-1.2 1.2-1.2h9.6l1.3 1.8c1.9-1.8 4.6-2.7 7.7-2.7 9.2 0 15.4 5.4 15.4 13.3v13.2q0 1.2-1.2 1.2h-8.7q-1.2 0-1.2-1.2V31c0-3.2-2.4-5.1-6-5.1s-6 1.9-6 5.1v9.4q0 1.2-1.2 1.2Z"
      />
    </svg>
  );
}

export function BrandLogo({
  inverse = false,
  compact = false,
}: {
  inverse?: boolean;
  compact?: boolean;
}) {
  return (
    <span className={`brand-logo ${inverse ? "brand-logo-inverse" : ""}`}>
      <BrandMark />
      {!compact && <span>NovaName</span>}
    </span>
  );
}
